import React from 'react';
import {
    getIsActiveLink,
    mapLinkToListItem,
} from '@pluto/sidebar-list-item';
import Storage from '@material-ui/icons/Storage';
import {baseRoutes} from '../../../AppRouter/routes';
import {envAuth} from '../../../../Login/Redux/LoginReducer';

interface QCOperatorLinksProps {
    path: string;
    roles: string[];
}

export const QC_OPERATOR_LINKS = [{
    route: baseRoutes.qcJobs,
    icon: <Storage />,
    title: 'QC Work Queue',
}];

export default function QCOperatorLinks(props: QCOperatorLinksProps) {
    const {
        path,
        roles,
    } = props;
    
    if (!envAuth && !roles.includes('qcOperator'))
        return null;
    
    const withPath = getIsActiveLink(path);
    const mapItems = mapLinkToListItem(withPath);
    const qcOperatorLinks = QC_OPERATOR_LINKS.map(mapItems);
    
    return (
        <>
            {qcOperatorLinks}
        </>
    );
}
